import React from 'react';
import { Typography, Box } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { iRootState } from '../redux/store';
import useOnPaymentPage from './useOnPaymentPage';

const QuoteTitle = function QuoteTitle(): React.ReactElement | null {
  const dealerName = useSelector((state: iRootState) => state.quote.dealerName);
  const title = useSelector((state: iRootState) => state.quote.title);
  const onPaymentPage = useOnPaymentPage();

  if (!dealerName || !title) {
    return null;
  }

  return (
    <Typography variant='h5'>
      <Box fontWeight='fontWeightBold' component='span'>
        {dealerName}
      </Box>
      {!onPaymentPage && (
        <Box fontWeight='fontWeightLight' component='span'>
          {` | ${title}`}
        </Box>
      )}
    </Typography>
  );
};

export default QuoteTitle;
